import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const [isMobileCountryOpen, setIsMobileCountryOpen] = useState(false);
  const mobileMenuRef = useRef(null);
  const burgerRef = useRef(null);
  
  const [activeLink, setActiveLink] = useState({
    home: true,
    services: false,
    student_visa: false,
    university_admission: false,
    scholarship_guidance: false,
    test_preparation: false,
    documentation: false,
    country: false,
    australia: false,
    canada: false,
    denmark: false,
    finland: false,
    ireland: false,
    new_york: false,
    new_zealand: false,
    sweden: false,
    uk: false,
    about: false,
  });

  useEffect(() => {
    const path = location.pathname;
    // console.log('Current path:', path);
    
    // Create a new state object with all links set to false
    const newActiveLink = {
      home: false,
      services: false,
      student_visa: false,
      university_admission: false,
      scholarship_guidance: false,
      test_preparation: false,
      documentation: false,
      country: false,
      australia: false,
      canada: false,
      denmark: false,
      finland: false,
      ireland: false,
      new_york: false,
      new_zealand: false,
      sweden: false,
      uk: false,
      about: false
    };
    
    // Set the appropriate link as active based on the current path
    if (path === '/') {
      newActiveLink.home = true;
    } else if (path.startsWith('/country/')) {
      newActiveLink.country = true;
      // Extract the country name from the path
      const countryName = path.split('/')[2];
      if (countryName && newActiveLink.hasOwnProperty(countryName)) {
        newActiveLink[countryName] = true;
      }
    } else if (path === '/services') {
      newActiveLink.services = true;
    } else if (path === '/about') {
      newActiveLink.about = true;
    }
    
    // console.log('Setting active links:', newActiveLink);
    setActiveLink(newActiveLink);
  }, [location.pathname]);

  const closeDropdowns = () => {
    setShowServicesDropdown(false);
    setShowCountryDropdown(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    // Close sub-menus when main menu is toggled
    setIsMobileServicesOpen(false);
    setIsMobileCountryOpen(false);
  };

  const toggleMobileServices = () => {
    setIsMobileServicesOpen(!isMobileServicesOpen);
    setIsMobileCountryOpen(false); // Close other sub-menu
  };

  const toggleMobileCountry = () => {
    setIsMobileCountryOpen(!isMobileCountryOpen);
    setIsMobileServicesOpen(false); // Close other sub-menu
  };

  const closeAllMenus = () => {
    setIsMobileMenuOpen(false);
    setIsMobileServicesOpen(false);
    setIsMobileCountryOpen(false);
  };

  // Handle click outside to close menus
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) &&
          burgerRef.current && !burgerRef.current.contains(event.target)) {
        closeAllMenus();
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <span><i className="fas fa-phone"></i> +880-1711751037</span>
              <span><i className="fas fa-envelope"></i> info@edugration-bd.com</span>
            </div>
            {/* <div className="track-application">
              <a href="#track">Track your Application</a>
            </div> */}
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="main-header">
        <div className="container">
          <div className="header-content">
            <div className='header-logo'>
            <div className="logo">
              <a href="/"><img src="/brand_logo-edited.png" alt="Edugration Logo" className="logo-image" /></a>
            </div>
            
              {/* Mobile Burger Menu */}
              <button 
                ref={burgerRef}
                className="mobile-burger"
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
              >
                <span className={`burger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
                <span className={`burger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
                <span className={`burger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
              </button>
            </div>
            
            {/* Desktop Navigation */}
            <nav className="main-nav desktop-nav">
              <ul>
                <li>
                  <Link 
                    to="/" 
                    className={activeLink.home ? 'active' : ''}
                  >
                    Home
                  </Link>
                </li>
                <li className="dropdown"
                  onMouseEnter={() => setShowServicesDropdown(true)}
                  onMouseLeave={() => setShowServicesDropdown(false)}
                >
                  <Link 
                    to="/services" 
                    className={activeLink.services ? 'active' : ''}
                  >
                    Services
                  </Link>
                  {/* {showServicesDropdown && (
                    <div className="dropdown-menu services-dropdown">
                      <Link to="/services/student-visa" className={activeLink.student_visa ? 'active' : ''} onClick={closeDropdowns}>Student Visa</Link>
                      <Link to="/services/university-admission" className={activeLink.university_admission ? 'active' : ''} onClick={closeDropdowns}>University Admission</Link>
                      <Link to="/services/scholarship-guidance" className={activeLink.scholarship_guidance ? 'active' : ''} onClick={closeDropdowns}>Scholarship Guidance</Link>
                      <Link to="/services/test-preparation" className={activeLink.test_preparation ? 'active' : ''} onClick={closeDropdowns}>Test Preparation</Link>
                      <Link to="/services/documentation" className={activeLink.documentation ? 'active' : ''} onClick={closeDropdowns}>Documentation</Link>
                    </div>
                  )} */}
                </li>
                <li className="dropdown"
                  onMouseEnter={() => setShowCountryDropdown(true)}
                  onMouseLeave={() => setShowCountryDropdown(false)}
                >
                  <Link 
                    className={activeLink.country ? 'active' : ''}
                  >
                    Country
                  </Link>
                  {showCountryDropdown && (
                    <div className="dropdown-menu country-dropdown">
                      <Link to="/country/australia" className={activeLink.australia ? 'active' : ''} onClick={closeDropdowns}>Australia</Link>
                      <Link to="/country/canada" className={activeLink.canada ? 'active' : ''} onClick={closeDropdowns}>Canada</Link>
                      <Link to="/country/denmark" className={activeLink.denmark ? 'active' : ''} onClick={closeDropdowns}>Denmark</Link>
                      <Link to="/country/finland" className={activeLink.finland ? 'active' : ''} onClick={closeDropdowns}>Finland</Link>
                      <Link to="/country/ireland" className={activeLink.ireland ? 'active' : ''} onClick={closeDropdowns}>Ireland</Link>
                      <Link to="/country/new-york" className={activeLink.new_york ? 'active' : ''} onClick={closeDropdowns}>New York</Link>
                      <Link to="/country/new-zealand" className={activeLink.new_zealand ? 'active' : ''} onClick={closeDropdowns}>New Zealand</Link>
                      <Link to="/country/sweden" className={activeLink.sweden ? 'active' : ''} onClick={closeDropdowns}>Sweden</Link>
                      <Link to="/country/uk" className={activeLink.uk ? 'active' : ''} onClick={closeDropdowns}>United Kingdom</Link>
                    </div>
                  )}
                </li>
                <li>
                  <Link 
                    to="/about" 
                    className={activeLink.about ? 'active' : ''}
                  >
                    About
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Mobile Navigation */}
            <nav ref={mobileMenuRef} className={`main-nav mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
              <ul>
                <li>
                  <Link 
                    to="/" 
                    className={activeLink.home ? 'active' : ''}
                    onClick={closeAllMenus}
                  >
                    Home
                  </Link>
                </li>
                <li className="mobile-dropdown">
                  <Link 
                    to="/services" 
                    className={activeLink.services ? 'active' : ''}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleMobileServices();
                    }}
                  >
                    Services
                    <i className={`fas fa-chevron-down ${isMobileServicesOpen ? 'rotate' : ''}`}></i>
                  </Link>
                  {/* {isMobileServicesOpen && (
                    <div className="mobile-dropdown-menu">
                      <Link to="/services/student-visa" className={activeLink.student_visa ? 'active' : ''} onClick={closeAllMenus}>Student Visa</Link>
                      <Link to="/services/university-admission" className={activeLink.university_admission ? 'active' : ''} onClick={closeAllMenus}>University Admission</Link>
                      <Link to="/services/scholarship-guidance" className={activeLink.scholarship_guidance ? 'active' : ''} onClick={closeAllMenus}>Scholarship Guidance</Link>
                      <Link to="/services/test-preparation" className={activeLink.test_preparation ? 'active' : ''} onClick={closeAllMenus}>Test Preparation</Link>
                      <Link to="/services/documentation" className={activeLink.documentation ? 'active' : ''} onClick={closeAllMenus}>Documentation</Link>
                    </div>
                  )} */}
                </li>
                <li className="mobile-dropdown">
                  <Link 
                    to="/country" 
                    className={activeLink.country ? 'active' : ''}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleMobileCountry();
                    }}
                  >
                    Country
                    <i className={`fas fa-chevron-down ${isMobileCountryOpen ? 'rotate' : ''}`}></i>
                  </Link>
                  {isMobileCountryOpen && (
                    <div className="mobile-dropdown-menu">
                      <Link to="/country/australia" className={activeLink.australia ? 'active' : ''} onClick={closeAllMenus}>Australia</Link>
                      <Link to="/country/canada" className={activeLink.canada ? 'active' : ''} onClick={closeAllMenus}>Canada</Link>
                      <Link to="/country/denmark" className={activeLink.denmark ? 'active' : ''} onClick={closeAllMenus}>Denmark</Link>
                      <Link to="/country/finland" className={activeLink.finland ? 'active' : ''} onClick={closeAllMenus}>Finland</Link>
                      <Link to="/country/ireland" className={activeLink.ireland ? 'active' : ''} onClick={closeAllMenus}>Ireland</Link>
                      <Link to="/country/new-york" className={activeLink.new_york ? 'active' : ''} onClick={closeAllMenus}>New York</Link>
                      <Link to="/country/new-zealand" className={activeLink.new_zealand ? 'active' : ''} onClick={closeAllMenus}>New Zealand</Link>
                      <Link to="/country/sweden" className={activeLink.sweden ? 'active' : ''} onClick={closeAllMenus}>Sweden</Link>
                      <Link to="/country/uk" className={activeLink.uk ? 'active' : ''} onClick={closeAllMenus}>United Kingdom</Link>
                    </div>
                  )}
                </li>
                <li>
                  <Link 
                    to="/about" 
                    className={activeLink.about ? 'active' : ''}
                    onClick={() => {
                      closeAllMenus();
                    }}
                  >
                    About
                  </Link>
                </li>
              </ul>
            </nav>

            <div className="header-actions">
              <Link to="/apply">
                <button className="btn btn-primary">
                  Apply Now
                  <div className="action-icon">
                    <i className="fas fa-arrow-right"></i>
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
